import React from "react";
import type { TabProps } from "../types";

const Tab = ({ children, title, tabKey, ...rest }: TabProps) => {
  return (
    <div
      id={`${tabKey}-tab`}
      aria-label={title}
      data-role="tab-content"
      {...rest}
    >
      {children}
    </div>
  );
};

export default Tab;
